import { createFileRoute } from '@tanstack/react-router';
import {
  ExternalDisplayRoot,
  type DisplaySearch,
} from 'containers/ExternalDisplay/ExternalDisplayFeature';

const validateSearch = (search: Record<string, unknown>): DisplaySearch => ({
  role: search.role === 'display' ? 'display' : undefined,
  parentOrigin:
    typeof search.parentOrigin === 'string' ? search.parentOrigin : undefined,
  orientation:
    search.orientation === 'portrait' || search.orientation === 'landscape'
      ? search.orientation
      : undefined,
  theme:
    search.theme === 'light' || search.theme === 'dark'
      ? search.theme
      : undefined,
  layout: typeof search.layout === 'string' ? search.layout : undefined,
});

export const Route = createFileRoute('/display/$deviceId')({
  validateSearch,
  component: DisplayDeviceRoute,
});

function DisplayDeviceRoute() {
  return (
    <ExternalDisplayRoot
      deviceId={Route.useParams().deviceId}
      search={Route.useSearch()}
    />
  );
}
